import React from 'react';
import Navigation from '../components/Navigation';
import SEO from '../components/SEO';

function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Privacy Policy - FreeDisposableEmail.com | How We Protect Your Data"
        description="Read FreeDisposableEmail.com's privacy policy. Learn how we collect, use, and protect your information when using our temporary email service."
        keywords="privacy policy, data protection, email privacy, temporary email privacy, user privacy, GDPR"
      />
      <Navigation />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              <strong>Last updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Introduction</h2>
              <p className="text-gray-700 mb-4">
                FreeDisposableEmail.com ("we", "our", or "us") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, and safeguard information when you use 
                our temporary email service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Information We Collect</h2>
              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Automatically Collected Information</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>IP addresses for security and abuse prevention</li>
                <li>Browser type and version</li>
                <li>Device information</li>
                <li>Usage patterns and access times</li>
              </ul>
              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Email Content</h3>
              <p className="text-gray-700 mb-4">
                We temporarily store emails sent to your disposable email addresses. These emails are 
                automatically deleted after 30 minutes or when you delete your inbox.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">How We Use Your Information</h2>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>To provide and maintain our service</li>
                <li>To prevent abuse and ensure security</li>
                <li>To improve our service and user experience</li>
                <li>To comply with legal obligations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Data Storage and Security</h2>
              <p className="text-gray-700 mb-4">
                We implement industry-standard security measures to protect your data. However, please note:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Emails are stored temporarily and automatically deleted after 30 minutes</li>
                <li>We do not require registration or personal information</li>
                <li>We use encryption to protect data in transit</li>
                <li>We do not sell or share your information with third parties</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Cookies and Tracking</h2>
              <p className="text-gray-700 mb-4">
                We use minimal cookies for essential functionality only. We do not use tracking cookies 
                or third-party analytics that identify individual users.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Third-Party Services</h2>
              <p className="text-gray-700 mb-4">
                Our service may use third-party services (such as email delivery providers) that have 
                their own privacy policies. We are not responsible for the privacy practices of these 
                third-party services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Your Rights</h2>
              <p className="text-gray-700 mb-4">You have the right to:</p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Delete your inbox and all associated emails at any time</li>
                <li>Use our service without providing personal information</li>
                <li>Contact us with privacy concerns</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Children's Privacy</h2>
              <p className="text-gray-700 mb-4">
                Our service is not intended for children under 13. We do not knowingly collect information 
                from children under 13.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Changes to This Policy</h2>
              <p className="text-gray-700 mb-4">
                We may update this Privacy Policy from time to time. We will notify you of any changes 
                by posting the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <p className="text-gray-700">
                <strong>Email:</strong> privacy@freedisposableemail.com<br />
                <strong>Website:</strong> <a href="/contact" className="text-primary-600 hover:underline">Contact Page</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
